__turbopack_context__.v({
  "popular-searches": "popular-searches-module-scss-module__MjuiOG__popular-searches",
  "wrap": "popular-searches-module-scss-module__MjuiOG__wrap",
});
